import { atom } from 'jotai'

export type TCheckBAIDResponse = {
    baid: string
    name: string
    status: string
    joinDate: string
    type: string
    verify: string
}

export type TGetDistributorInformationResponse = {
    status: string
    token: string
    href: string
}

export const distributorSearchValueAtom = atom('')
export const distributorIsLoadingAtom = atom(false)
export const distributorErrorAtom = atom('')
export const distributorRecordsAtom = atom<TCheckBAIDResponse[]>([])
export const distributorCustomerInformationAtom = atom<TGetDistributorInformationResponse | null>(null)
